export default __webpack_public_path__ + "static/media/rarity6.85e66020.mp4";